<script lang="ts">
  export let speed = '1.0x';
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$restProps}
  ><path
    fill="currentColor"
    fill-rule="evenodd"
    d="M12 1.183c2.572 0 4.928.907 6.778 2.413l1.62-1.62 1.224 1.225.188.19-9.425 9.425-1.414-1.415 6.302-6.3A8.589 8.589 0 0 0 12 3.297c-4.76 0-8.635 3.874-8.635 8.635v.25H1.25v-.25c0-5.938 4.813-10.75 10.75-10.75Zm8.635 10.75v.25h2.115v-.25c0-1.899-.495-3.68-1.36-5.227l-.16-.29-1.563 1.563.08.161a8.535 8.535 0 0 1 .888 3.792Z"
    clip-rule="evenodd"
  /><text x="2" y="22" fill="currentColor" font-family="Roboto, sans-serif" font-size="10" font-weight="700"
    >{speed}</text
  ></svg
>
